import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=133cd4dc&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=133cd4dc&prod&scoped=scoped&lang=less"
import style1 from "./Index.vue?vue&type=style&index=1&id=133cd4dc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133cd4dc",
  null
  
)

export default component.exports